import { store } from '../redux/configure-store';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

export const validateAlternateIdOrPhoneLength = (value: string): Promise<void> => {
  const { validateAlternateId } = getCurrentXLRConfig();
  const MIN_DIGITS_LENGTH = validateAlternateId ? 4 : 1;

  const valueLength = value.length;
  const alternateIdMinLength = store.getState().touchPoint.touchPointConfiguration
    .alternateIdMinLength;
  const alternateIdMaxLength = store.getState().touchPoint.touchPointConfiguration
    .alternateIdMaxLength;
  const alternateIdSellingEngineMinLength = store.getState().touchPoint.touchPointConfiguration
    .alternateIdSellingEngineMinLength;
  const alternateIdSellingEngineMaxLength = store.getState().touchPoint.touchPointConfiguration
    .alternateIdSellingEngineMaxLength;

  if (validateAlternateId) {
    return new Promise((resolve, reject) => {
      if (!validateDigitsLength(value, MIN_DIGITS_LENGTH)) {
        if (alternateIdMinLength && valueLength < alternateIdMinLength) {
          reject(getCustomerDetailsMinMaxValidatorReason());
        } else {
          reject({
            t: 'CustomerDetailsMinDigitsValidator',
            args: {
              arg: MIN_DIGITS_LENGTH,
            },
          });
        }
      }

      if (
        valueLength === 0 ||
        (alternateIdMaxLength &&
          valueLength <= alternateIdMaxLength &&
          alternateIdMinLength &&
          valueLength >= alternateIdMinLength)
      ) {
        resolve();
      } else {
        reject(getCustomerDetailsMinMaxValidatorReason());
      }
    });
  } else {
    return new Promise((resolve, reject) => {
      if (!validateDigitsLength(value, MIN_DIGITS_LENGTH) && validateAllDigits(value)) {
        if (alternateIdSellingEngineMinLength && valueLength < alternateIdSellingEngineMinLength) {
          reject(getCustomerDetailsMinMaxValidatorReason());
        } else {
          reject({
            t: 'CustomerDetailsMinDigitsValidator',
            args: {
              arg: alternateIdSellingEngineMinLength,
            },
          });
        }
      } else {
        if (
          valueLength === 0 ||
          (alternateIdSellingEngineMaxLength &&
            valueLength <= alternateIdSellingEngineMaxLength &&
            alternateIdSellingEngineMinLength &&
            valueLength >= alternateIdSellingEngineMinLength &&
            validateAllDigits(value))
        ) {
          resolve();
        } else if (!validateAllDigits(value)) {
          reject({
            t: 'CustomerDetailsNumberOnlyValidator',
          });
        } else {
          reject(getCustomerDetailsMinMaxValidatorReason());
        }
      }
    });
  }
  function getCustomerDetailsMinMaxValidatorReason() {
    if (validateAlternateId) {
      return {
        t: 'CustomerDetailsMinMaxValidator',
        args: {
          arg: alternateIdMinLength,
          arg2: alternateIdMaxLength,
        },
      };
    } else {
      return {
        t: 'CustomerDetailsMinMaxValidator',
        args: {
          arg: alternateIdSellingEngineMinLength,
          arg2: alternateIdSellingEngineMaxLength,
        },
      };
    }
  }
};

export const validateDigitsLength = (value: string, allowedLength: number) => {
  return (value.match(/[\d]+/gi)?.join('').length ?? 0) >= allowedLength;
};

export const validatePhoneNumber = (value: string): boolean => {
  return new RegExp(/^[+]?[0-9]{10,30}$/).test(value);
};

export const validateAllDigits = (value: string) => {
  return new RegExp(/^[0-9]*$/).test(value);
};

export const validateEmail = (email: string): boolean => {
  return new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ).test(email);
};
